/* global google */
/* Use HereMap Instead Now*/

import {fetchWithHere, getFetchedJSON} from '~/misc/fetch';
import config from '~/config'



import { decode } from "~/misc/polyline"
import {formatTimeDuration} from '~/misc/dates';

const metersToMilesRatio = 1 / 1609.344;



const reducePointsLimit = (court) => {
  return court/1000 > 1 ? Math.floor(court/1000)  : 1;
}

const pickPoint = (points) => {
  const { length } = points;
  const step = reducePointsLimit(length)
  return points.filter((e, i) => i%step === 0);
}
//transform here points to G style

const convertToGFormat = points => 
  points.map(([lat, lng])=> ({
    lat: ()=>lat,
    lng: ()=>lng
  }))

const getPolyline = ( origin, destination) => {
  return fetchWithHere(() => {
    return {
      user: {
        token: 1
      }
    }
  }, {
    method: 'GET',
    url: `/routes?apikey=${config.hereMapsApiKey}&origin=${origin.lat},${origin.lng}&destination=${destination.lat},${destination.lng}&return=polyline&transportMode=truck`, 
  }).then(getFetchedJSON).then(data => {
    const { routes } = data;
    if(routes.length === 0) throw new Error("None Route");

    const { sections } = routes[0];
    if(sections.length === 0) throw new Error("None Sections");

    const { polyline: polylineText } = sections[0];
    const { polyline } = decode(polylineText);

    return {
      path : convertToGFormat(pickPoint(polyline))
    }
  }).catch(e=>{
    console.log(e);
  })
}


const getDistance = (origin, destination) => {
  return fetchWithHere(() => {
    return {
      user: {
        token: 1
      }
    }
  }, {
    method: 'GET',
    url: `/routes?apikey=${config.hereMapsApiKey}&origin=${origin.lat},${origin.lng}&destination=${destination.lat},${destination.lng}&return=summary&transportMode=truck`, 
  }).then(getFetchedJSON).then(data=> {
    const { routes } = data;
    if(routes.length === 0) throw new Error("None Route");

    const { sections } = routes[0];
    if(sections.length === 0) throw new Error("None Sections");

    const { summary: { length } } = sections[0];
    return Math.round(length * metersToMilesRatio);
  })
}
const getDrivingTime = ({origin, destination}) => {
  return fetchWithHere(() => {
    return {
      user: {
        token: 1
      }
    }
  }, {
    method: 'GET',
    url: `/routes?apikey=${config.hereMapsApiKey}&origin=${origin.lat},${origin.lng}&destination=${destination.lat},${destination.lng}&return=summary&transportMode=truck`, 
  }).then(getFetchedJSON).then(data=> {
    const { routes } = data;
    if(routes.length === 0) throw new Error("None Route");

    const { sections } = routes[0];
    if(sections.length === 0) throw new Error("None Sections");

    const { summary: { duration } } = sections[0];
    //duration: minute
    return formatTimeDuration(duration* 1000,false)
  })
}

export {
  getPolyline,
  getDistance,
  getDrivingTime
};



// WEBPACK FOOTER //
// ./src/api/map.js